import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import routes from '../scripts/Routes.js';
import propTypes from "prop-types";
import moment from 'moment';
import 'moment/locale/pl';
import Cookies from 'universal-cookie';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions';

// import components
import Header from './Header.js';
import Footer from './Footer.js';
import Search from './Search.js';
import CookieBar from '../components/CookieBar.js';
import WelcomeBar from '../components/WelcomeBar.js';
import ScrollTop from '../components/ScrollTop.js';
import Alerts from '../components/alerts/Alerts.js';

const cookies = new Cookies();

class App extends Component {
	constructor() {
		super();
		this.state = {
			showBackButton: false,
			isCookieBar: !cookies.get('cookieAlert'),
			isWelcomeBar: !cookies.get('isWelcomeBar'),
			isMobile: false,
			isMobileSmall: false,
			isMobileMenu: false,
			isMenuFixed: false,
		};
	};

	componentDidMount() {
		const { currentLanguage, history, actions } = this.props;
		const { isCookieBar, isWelcomeBar } = this.state;

		history.listen((location, action) => {
			// clear alert on location change
			actions.alertActionsClear();
		});

		// to test:
		// cookies.remove('cookieAlert')
		// cookies.remove('isWelcomeBar')

		if (isCookieBar) {
			cookies.set('cookieAlert', 'close', { path: '/' });
		}

		if (isWelcomeBar) {
			cookies.set('isWelcomeBar', 'close', { path: '/' });
		}

		moment.locale(currentLanguage);
		this.updateDimensions();
		window.addEventListener("resize", this.updateDimensions.bind(this));

		this.domNode = ReactDOM.findDOMNode(this.searchTab);
		this.updateScroll();
		window.addEventListener('scroll', this.updateScroll.bind(this));

		actions.getDictionary();
	};

	componentDidUpdate(prevProps, nextState) {
		if (this.props.currentLanguage !== prevProps.currentLanguage) {
			moment.locale(this.props.currentLanguage);
		}

		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.scrollTop();
		}

		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.setState({ previousLocation: prevProps.location });
		}
	};

	componentWillReceiveProps(nextProps) {
		const routeChanged = nextProps.location !== this.props.location;

		this.setState({ showBackButton: routeChanged });

		if (routeChanged) {
			this.setState({ isMobileMenu: false });
		}
	};

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
		window.removeEventListener('scroll', this.updateScroll.bind(this));
	};

	updateDimensions = () => {
		this.setState({ isMobile: window.innerWidth <= 1300, isMobileSmall: window.innerWidth <= 800 });
	};

	updateScroll = () => {
		if (this.domNode) {
			this.tabListOffset = this.domNode.getBoundingClientRect();
			this.setState({ isMenuFixed: this.tabListOffset.top + this.tabListOffset.height < 0 });
		}
	};

	toggleMobileMenu = () => {
		const { isMobile, isMobileMenu } = this.state;

		if (isMobile) {
			this.setState({ isMobileMenu: !isMobileMenu });
		}
	};

	getComponent = (type, props, to) => {
		const { showBackButton, isMobile, isMobileSmall, previousLocation } = this.state;
		const ItemComponent = type;

		return <ItemComponent { ...props } showBackButton={ showBackButton } isMobile={ isMobile } isMobileSmall={ isMobileSmall } to={ to } previousLocation={ previousLocation } />;
	};

	closeCookieBar = () => {
		this.setState({ isCookieBar: false });
	};

	closeWelcomeBar = () => {
		this.setState({ isWelcomeBar: false });
	};

	scrollTop = () => {
		window.scrollTo(0, 0);
	};

	render() {
		const { isCookieBar, isWelcomeBar, isMobileMenu, isMobile, isMobileSmall, isMenuFixed } = this.state;
		const { isFieldsOpen, alert } = this.props;
		const isFixed = isMobileMenu || (isFieldsOpen && isMobileSmall) || isWelcomeBar;

		return (
			<div className={ `app ${isFixed ? 'fixed' : ''}` } id="app">
				<div className="app__top">
					<Header
						toggleMobileMenu={ this.toggleMobileMenu }
						isMobile={ isMobile }
						isMobileMenu={ isMobileMenu }
						isMenuFixed={ isMenuFixed } />

					<div ref={ el => this.searchTab = el }>
						<Search />
					</div>
				</div>

				<Alerts alert={ alert } />

				<Switch>
					{ routes.map((route) => (
						<Route
							key={ route.id } exact={ route.exact } path={ route.path }
							render={ (props) => (this.getComponent(route.component, props, route.to)) }
						/>)) }
				</Switch>

				<Footer />

				{ isMenuFixed && <ScrollTop scrollTop={ this.scrollTop } /> }
				{ isCookieBar && <CookieBar closeCookieBar={ this.closeCookieBar } /> }
				{ isWelcomeBar && <WelcomeBar closeWelcomeBar={ this.closeWelcomeBar } /> }
			</div>
		);
	};
};

App.propTypes = {
	routes: propTypes.arrayOf(
		propTypes.shape({
			id: propTypes.number.isRequired,
			path: propTypes.string,
			exact: propTypes.bool,
			component: propTypes.object
		}
		).isRequired),
	currentLanguage: propTypes.string.isRequired,
	actions: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
	currentLanguage: state.language.currentLanguage,
	isFieldsOpen: state.simpleSearchResults.isFieldsOpen,
	alert: state.alert,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Actions, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js